module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes
  }, [(_vm.label) ? _c('label', {
    class: [_vm.prefixCls + '-label'],
    style: (_vm.labelStyles)
  }, [_vm._t("label", [_vm._v(_vm._s(_vm.label))])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    class: [_vm.prefixCls + '-content'],
    style: (_vm.contentStyles)
  }, [_vm._t("default"), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.validateState === 'error' && _vm.showMessage && _vm.form.showMessage) ? _c('div', {
    class: [_vm.prefixCls + '-error-tip']
  }, [_vm._v(_vm._s(_vm.validateMessage))]) : _vm._e()])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-221057a5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview/src/components/form/form-item.vue
// module id = 603
// module chunks = 1